import React from "react";
import styled from "styled-components";

import testImage from "./testImage.jpg";

const DeviceContainer = styled.div`
  width: 1920px;
  height: 1080px;
  background: red;
`;

const CampaignContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: green;
`;

const BlockContainer = styled.div`
  position: absolute;
  top: ${({ top = 0 }) => `${top}%`};
  left: ${({ left = 0 }) => `${left}%`};
  width: ${({ widthPercentage = 100 }) => `${widthPercentage}%`};
  height: ${({ heightPercentage = 100 }) => `${heightPercentage}%`};
  background: ${({ background = "red" }) => background};
`;

export default () => {
  const DEVICE_WIDTH = 1920;
  const DEVICE_HEIGHT = 1080;

  const CAMPAIGN_WIDTH = 3952;
  const CAMPAIGN_HEIGHT = 936;

  const BLOCK_WIDTH = 1976;
  const BLOCK_HEIGHT = 936;

  console.log("3952 / 1976", (BLOCK_WIDTH / CAMPAIGN_WIDTH) * 100);
  const BLOCK_POSITION_X = 1976;
  console.log("3952 / 1976", (BLOCK_POSITION_X / CAMPAIGN_WIDTH) * 100);

  return (
    <DeviceContainer>
      <CampaignContainer>
        <BlockContainer
          widthPercentage={(BLOCK_WIDTH / CAMPAIGN_WIDTH) * 100}
        ></BlockContainer>
        <BlockContainer
          background="yellow"
          left={(BLOCK_POSITION_X / CAMPAIGN_WIDTH) * 100}
          widthPercentage={(BLOCK_WIDTH / CAMPAIGN_WIDTH) * 100}
        ></BlockContainer>
      </CampaignContainer>
    </DeviceContainer>
  );
};
